import gql from 'graphql-tag';
import { DirectoryFragments } from './directory.fragments';

export class DirectoryQueries {
  static resourceDirectoriesQuery = gql`
    query ResourceDirectories($directory: String!) {
      resourceDirectories(directory: $directory) {
        ...directoryFragment
      }
    }
    ${DirectoryFragments.directoryFragment}
  `;
}
